module.exports = __webpack_public_path__ + "static/media/stablesThumb2.d3a52180.jpg";